import { sessionListSearchValueAtom } from '@/atoms/sideNavAtoms';
import { Button } from '@heidi/design-system/button';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { useAtom } from 'jotai';
import { CalendarX } from 'lucide-react';
import { memo } from 'react';

const EhrSessionNotFoundResult = memo(() => {
  const { t } = useTranslations();
  const [sessionListSearchValue, setSessionListSearchValue] = useAtom(
    sessionListSearchValueAtom
  );

  return (
    <>
      <div className="content-center rounded-lg bg-background-tertiary p-4">
        <CalendarX size={23} className="text-text-secondary" />
      </div>
      <div className="relative flex flex-col items-center gap-2">
        <TypographyP2 className="text-text-secondary">
          {t('sessions.noSessionsFound')}
        </TypographyP2>
        {sessionListSearchValue && (
          <Button
            variant="ghost"
            size="xs"
            className="absolute top-6"
            onClick={() => setSessionListSearchValue('')}
          >
            <TypographyCaption>{t('sessions.clearFilters')}</TypographyCaption>
          </Button>
        )}
      </div>
    </>
  );
});

EhrSessionNotFoundResult.displayName = 'EhrSessionNotFoundResult';
export default EhrSessionNotFoundResult;
